var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwinRightAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00001 100C2.23858 100 0 97.7614 0 95L0 17.9213C0 13.4727 5.37349 11.2392 8.52685 14.3771L47.9023 53.5597L85.6245 91.4734C88.7621 94.6269 86.5285 100 82.08 100H5.00001Z",
    fill: "#5F5F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95 0C97.7614 0 100 2.23858 100 5V82.0787C100 86.5273 94.6265 88.7608 91.4732 85.6229L52.0977 46.4403L14.3755 8.52657C11.2379 5.3731 13.4715 0 17.92 0L95 0Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinRightAngleRight);
export default __webpack_public_path__ + "static/media/TwinRightAngleRight.6feb8c20db54d034235fcaa5f533f3c7.svg";
export { ForwardRef as ReactComponent };